export const breakpoints = {
  base: '0px',
  sm: '744px',
  md: '744px',
  lg: '960px',
  xl: '1200px',
  '2xl': '1536px',
};
